const styles = {
    container: {
        padding: 0,
        color: 'rgba(26,26,26,.9)'
    }
};

export default styles;


// WEBPACK FOOTER //
// ./src/containers/Home/HomeStyle.js